<template>
  <div>
    <van-sticky :offset-top="46">
      <van-search
        v-model="queryParams.capitalCode"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    <page-list ref='pageList' request-url="/capital" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="18">钱包账户: {{row.capitalCode}}</van-col>
          <van-col span="6">{{formatAccountType(row.accountType)}}</van-col>
          <van-col span="12">账户名称: {{row.accountName}}</van-col>
          <van-col span="12">总金额: {{row.totalAmount}}</van-col>
          <van-col span="12">已用金额: {{row.useAmount}}</van-col>
          <van-col span="12">余额: {{row.banlance}}</van-col>
          <van-col span ='24'>
            <van-row type="flex" justify="center" >
              <van-col span="12"><van-button type="info" size="small" block @click="openRechargeDrawer(row)">充值</van-button></van-col>
              <van-col span="12"><van-button type="default" size="small" block @click="openDeductDrawer(row)">扣减差额</van-button></van-col>
           </van-row>
          </van-col>
        </van-row>
      </template>
    </page-list>
    <down-drawer ref='rechargeDrawer' @close="handleRefresh" @confirm="onRechargeAmount" title="会员充值" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            name="chargeAmount"
            label="充值金额"
            input-align ='right'
            :rules="[{ required: true, message: '充值金额不能为空' }]">
            <template #input>
              <van-stepper v-model="model.chargeAmount" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
    <down-drawer ref='deductDrawer' @close="handleRefresh" @confirm="onDeductAmount" title="扣减差额" >
      <template #content>
        <van-form ref="deductForm" :validate-first="true" :show-error-message="false">
          <van-field
            name="deductAmount"
            label="扣除金额"
            input-align ='right'
            :rules="[{ required: true, message: '扣除金额不能为空' }]">
            <template #input>
              <van-stepper v-model="model.deductAmount" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'UserWalletList',
  components: { PageList },
  created () {
  },
  data () {
    return {
      subId: null,
      model: {},
      queryParams: {
        capitalCode: null
      }
    }
  },
  computed: {

  },
  methods: {
    formatAccountType (type) {
      if (type === 'CUST') {
        return '客户'
      } else if (type === 'POS') {
        return '商家'
      } else if (type === 'DRIVER') {
        return '司机'
      } else if (type === 'COURIER') {
        return '配送员'
      } else if (type === 'KEEPER') {
        return '仓管'
      }
      return '未知类型'
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.capitalCode = this.queryParams.capitalCode
      params.accountName = null
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    openRechargeDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.$set(this.model, 'chargeAmount', 0)
      // this.model.chargeAmount = 0
      this.$refs.rechargeDrawer.show = true
    },
    onRechargeAmount () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.user.recharge(this.model.id, { amount: this.model.chargeAmount }).then(response => {
          if (response.success) {
            this.$toast.success('充值成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.rechargeDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    openDeductDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.$set(this.model, 'deductAmount', 0)
      // this.model.chargeAmount = 0
      this.$refs.deductDrawer.show = true
    },
    onDeductAmount () {
      // 触发表单验证
      this.$refs.deductForm.validate().then(() => {
        this.$api.user.deductDiffAmount(this.model.id, { amount: this.model.deductAmount }).then(response => {
          if (response.success) {
            this.$toast.success('扣减成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.deductDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
</style>
